module.exports = __webpack_public_path__ + "static/media/matching-score-coin-100.efb80bc8.png";